/**
 * Instagram publication edit policy driven by Meta Graph API limits.
 *
 * Meta's ``POST /{ig-media-id}`` only toggles ``comment_enabled``; it cannot
 * update captions or media in place. Housien therefore hides the Edit entry
 * point for Instagram and keeps API rejection as a safety net.
 */

/**
 * Returns true when Edit must not be offered for the portal.
 */
export function isInstagramEditHidden(portal: string): boolean {
  return portal === 'instagram';
}

/**
 * Returns true when the API error body is Instagram edit_not_supported.
 */
export function isInstagramEditNotSupportedError(error: unknown): boolean {
  const data = (error as { response?: { data?: { error?: string; portal?: string } } })
    ?.response?.data;
  return data?.error === 'edit_not_supported' && data.portal === 'instagram';
}
